<template>
	<el-container id="app">
		<el-header class="website-log-box hidden-sm-and-down" v-if="!$mStore.state.isLoginPage">
			<el-row :gutter="8" class="container website-log-box-item" type="flex" justify="space-around">
				<el-col :xs="8" :sm="8" :md="6" :lg="8" :xl="10">
					<div class="website-name">诚鱼文化</div>
				</el-col>
				<el-col :md="10" class="hidden-sm-and-down"></el-col>
			</el-row>
		</el-header>
		<!-- 导航PC -->
		<el-header class="website-log-box hidden-xs-only" :class="$mStore.state.isShowHeader ? '' : 'none-dis'"
			v-if="!$mStore.state.isLoginPage">
			<el-row :gutter="10" class="container nav-list-box">
				<el-col :xs="24" :sm="3" :md="3" :lg="3" :xl="3" v-for="(item, index) in navList" :key="index">
					<div v-if="item.child && item.child.length > 0" @click="selectNav(index)">
						<el-dropdown class="pc-parent-nav">
							<span class="el-dropdown-link"
								:class="index == activeIndex ? 'el-dropdown-link-active' : ''">
								<router-link :class="index == activeIndex ? 'el-dropdown-link-active' : ''" to="/rules">
									{{ item.title}}<i class="el-icon-arrow-down el-icon--right"></i></router-link>
							</span>
						</el-dropdown>
					</div>
					<div class="grid-content el-dropdown-link bg-purple" @click="selectNav(index)"
						:class="index == activeIndex ? 'el-dropdown-link-active' : ''" v-else>
						<router-link to="/rules" :class="index == activeIndex ? 'el-dropdown-link-active' : ''">
							{{ item.title}}
						</router-link>
					</div>
				</el-col>
			</el-row>
		</el-header>
		<!-- 导航PC end -->
		<!-- 导航app -->
		<el-header class="app-nav hidden-sm-and-up" v-if="!$mStore.state.isLoginPage"
			:class="showAppNav ? 'website-log-box' : 'website-log-box-two'">
			<el-row class="container app-nav">
				<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" :class="showAppNav ? 'nav-bottom' : ''">
					<div class=" header-left">
						<!-- <img class="app-logo-img" src="assets/logo-1.jpg" /> -->
						<div class="website-name">诚鱼文化</div>
					</div>
				</el-col>
				<el-col class="right-btn" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
					<el-button @click="drawer = true" style="margin-left: 16px;">
						<div class="iconfont icon-liebiao" @click="openNav"></div>
					</el-button>
				</el-col>

				<el-drawer class="drawer-bg" size="70%" title="分类" :visible.sync="drawer" :direction="direction"
					:before-close="handleClose">
					<el-row :gutter="10" class="container nav-list-box hidden-sm-and-up">
						<el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3" v-for="(item, index) in navList" :key="index">
							<div class="grid-content el-dropdown-link bg-purple" @click="selectNav(index)"
								:class="index == activeIndex ? 'el-dropdown-link-active' : ''">
								<router-link v-if="item.title=='首页'" to="/"
									:class="index == activeIndex ? 'el-dropdown-link-active' : ''">
									{{ item.title}}</router-link>
								<!-- list_type=0普通排序，1为一行两列排序 -->
								<router-link v-else-if="item.list_type==0"
									:to="`/news?id=${item.id}&name=${item.title}`"
									:class="index == activeIndex ? 'el-dropdown-link-active' : ''">
									{{ item.title}}</router-link>
								<router-link v-else :to="`/rules?id=${item.id}&name=${item.title}`"
									:class="index == activeIndex ? 'el-dropdown-link-active' : ''">
									{{ item.title}}</router-link>
							</div>
						</el-col>
					</el-row>
				</el-drawer>
			</el-row>
		</el-header>
		<!-- 导航app end -->
		<!-- 轮播图 -->
		<el-row class="" v-if="urls&&urls.length>0">
			<el-carousel :interval="50000" arrow="always" class="" height='200px'>
				<el-carousel-item v-for="(item, index) in urls" :key="index" class="carousel-banner-item">
					<el-image :src="item.cover" @click="detail(item.id)"></el-image>
				</el-carousel-item>
			</el-carousel>
		</el-row>
		<!-- 轮播图end -->
		<!-- <a href="https://news.chengyu168.top/" class="back-page">< 返回首页</a> -->
		<div class="back-page" @click="goBack" v-if="!isWeixinMiniProgram">< 返回</div>
		<el-container class="main-box">
			<el-main class="main-content">
				<router-view />
			</el-main>
		</el-container>
		<el-footer>
			<div style="width: 100%;height: 45px;"></div>
			<div class="copyright">
				<div class="container clearfix">桂ICP备2026001189号-2</div>
			</div>
		</el-footer>
	</el-container>
</template>

<script>
	import 'bootstrap/dist/js/bootstrap.js'
	import 'bootstrap/dist/css/bootstrap.min.css'
	import 'bootstrap/dist/js/bootstrap.min'
	import router from './router';
	import IndexMain from './components/Index.vue'
	import moment from '@/utils/moment';
	import {
		Adv
	} from '@/api/adv';
	var adv = new Adv();
	export default {
		components: {
			IndexMain
		},
		data() {
			return {
				toPath: "", //下一个页面
				hasLogin: false,
				cartNum: 0, //购物车数量
				showAppNav: false,
				activeIndex: 0,
				is_index: true,
				input: '',
				navIndex: 0,
				navList: [{
					title: '首页',
					cover: ''
				}],
				drawer: false, //是否展示右侧菜单栏
				direction: 'rtl',
				urls: [],
				startX: 0,
				endX: 0,
				isWeixinMiniProgram:true
			}
		},
		computed: {
			currentPath() {
				return this.$route.path;
			}
		},
		created() {
			this.isWeixinMiniProgram = typeof wx !== 'undefined' && typeof wx.getSystemInfoSync === 'function';
			console.log(this.isWeixinMiniProgram)
			this.getBanner();
			this.getNavBar();
		},
		mounted() {

		},
		updated() {

		},
		filters: {
			// 时间格式化
			time(val) {
				return moment(val * 1000).format('YYYY-MM-DD HH:mm');
			},
		},
		methods: {
			//关闭右侧菜单
			handleClose(done) {
				done();
			},
			goBack(){
				router.back();
			},
			//广告
			getBanner() {
				var that = this;
				var param = {};
				adv.list(param).then(data => {
					that.urls = data.data;
				}).catch((res) => {});
			},
			//分类
			getNavBar() {
				var that = this;
				var param = {};
				adv.navbar(param).then(data => {
					that.navList = that.navList.concat(data.data);
				}).catch((res) => {});
			},
			selectNav(index) {

				this.drawer = false;
				this.activeIndex = index;
				this.showAppNav = !this.showAppNav;
				if (index != 0) {
					this.is_index = false;
				} else {
					this.is_index = true;
				}
			},
			//
			openNav() {
				this.showAppNav = !this.showAppNav;
			},
			//广告详情
			detail(id) {
				this.$router.push({
					path: '/bnDetail',
					query: {
						id: id
					}
				}).catch(() => {

				});
			}
		}
	};
</script>
<style scoped>
	#app {
		font-size: 14px;
		background-color: #fff;
		color: #333;
	}
	.back-page{
		margin: 20px 2% 0px !important;font-size: 16px;
		font-weight: bold;box-shadow: 0px 3px 5px rgb(0 0 0 / 10%);
		padding: 8px;border-radius: 4px;
	}

	.el-main {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
		padding: 0 !important
	}

	.main-box {
		/* margin-top: -40px; */
		margin-top: 20px;
		padding-bottom: 10px;
		position: relative;
		background: none;
		margin-bottom: 30px;
		z-index: 99;
	}

	.main-content {
		background: #fff;
		border-radius: 10px;
		padding: 20px;
		-moz-box-shadow-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
		box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
		margin: 2%;
		width: 96%;
	}

	.el-card__body,
	.el-main {
		padding: 0 !important
	}

	a {
		color: #333;
	}

	.container,
	.container-fluid,
	.container-xxl,
	.container-xl,
	.container-lg,
	.container-md,
	.container-sm {
		margin-left: auto !important;
		margin-right: auto !important;
	}

	.el-header {
		background-color: #fff !important;
		color: #333;
		line-height: 60px;
		height: auto !important;
	}

	.header-left {
		display: flex;
		align-items: center;
	}

	.logo-img {
		width: 50px;
		margin-right: 10px;
	}

	.website-log-box {
		padding: 20px 0 0 !important;

		&-item {
			display: flex;
			align-items: center;
		}
	}

	.website-log-box-two {
		padding: 20px !important;

		&-item {
			display: flex;
			align-items: center;
		}
	}

	.website-log-box-right {
		display: flex;
		align-items: center;
	}

	.website-name {
		font-size: 36px;
		color: #2c3096;
		font-weight: bold;
	}

	.nav-list .el-menu--horizontal>.el-menu-item {
		cursor: pointer;
		font-size: 16px;
	}

	.nav-list {
		padding: 20px 0 !important;
	}

	/deep/.el-drawer.rtl {
		background: #2c3096;
	}

	/deep/.el-drawer__header {
		color: #fff !important;
		border-bottom: 1px solid #fff;
		margin-bottom: 20px;
	}

	.drawer-bg a {
		color: #fff !important;
		display: block !important;
		width: 100%;
	}



	.el-menu.el-menu--horizontal {
		display: flex;
	}

	.el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: none !important;
		color: #20b483;
		padding: 0 40px;
		font-size: 16px;
	}

	.el-dropdown-link,
	.el-dropdown-link-item {
		font-size: 16px;
		cursor: pointer;
		text-align: left !important;
	}

	.el-dropdown-link-active,
	..el-dropdown-link a {
		color: #fff !important;
	}

	.el-image {
		position: relative;
		display: inline-block;
		overflow: hidden;
		height: 100%;
		width: 100%;
	}

	/* 广告位 */
	.carousel-horizontal .el-carousel__container {
		overflow: hidden;
		white-space: nowrap;
	}

	.carousel-horizontal .el-carousel__item {
		display: inline-block;
		margin-right: 10px;
	}

	/* 广告位end */

	.h1,
	.h2,
	.h3,
	.h4,
	.h5,
	.h6,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-family: inherit;
		font-weight: 500;
		line-height: 1.1;
		color: inherit;
	}

	a {
		text-decoration: none !important;
	}

	/* 底部 */
	.copyright {
		margin-top: 30px;
		background: #2c3096;
		padding: 10px 0;
		margin-left: -20px !important;
		margin-right: -20px;
		text-align: center;
		position: fixed;
		bottom: 0;
		width: 100%;
		z-index: 99;
	}

	.copyright .clearfix {
		color: #fff;
	}

	.el-dropdown-link {
		text-align: center !important;
	}

	.pc-parent-nav {
		position: relative !important;
		background-color: #20b483 !important;
		color: #fff;
		text-align: center;
		padding: 0 !important;
	}

	.pc-parent-nav .el-dropdown {
		width: 100%;
	}

	.pc-parent-nav .el-dropdown-link {
		padding-left: 5px;
		padding-right: 5px;

	}

	.pc-parent-nav .el-dropdown-link {
		color: #fff !important;
	}

	.pc-child-nav .el-dropdown-link-item {
		font-size: 16px;
		cursor: pointer;
		text-align: left;
		padding: 5px 20px;
	}

	/* 响应式 */
	/* 小屏幕（平板，大于等于 768px） */
	@media screen and (min-width: 768px) {
		/* 你的样式 */

	}

	@media only screen and (max-width: 767px) {
		.website-name {
			font-size: 20px;
			font-weight: bold;
		}

		.nav-list-box {
			display: flex;
			flex-wrap: wrap;
		}

		.el-dropdown-link {
			text-align: left;
		}

		.assure-box {
			display: block;
			padding: 20px 0 !important;
		}

		.el-dropdown {
			width: 100%;
			text-align: left;
		}

		.app-logo-img {
			width: 60px;
			margin-right: 10px;
		}

		.website-log-box {
			padding: 10px 0 !important;
		}

		.app-nav {
			padding: 0 5px !important;
		}

		.nav-bottom {
			border-bottom: 1px solid #ddd;
			padding: 10px;
		}

		.app-nav .el-dropdown-link {
			line-height: 50px !important;
			font-size: 14px;
		}

		.website-name {
			font-size: 18px;
			color: #2c3096;
			font-weight: bold;
		}

		.right-btn {
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}

		.right-btn .el-button {
			padding: 12px 0 !important;
			border: none !important;
		}

		.right-btn .el-button:focus,
		.right-btn .el-button:hover {
			color: #2c3096 !important;
			border-color: #fff !important;
			background-color: #fff !important;
		}

		.right-btn .iconfont {
			font-size: 36px !important;
			color: #2c3096 !important;
		}

		.app-nav .el-drawer__header {
			color: #fff !important;
		}

		.el-drawer,
		.el-drawer__open .el-drawer.rtl {
			animation: rtl-drawer-in .3s 1ms;
			background-color: #2c3096 !important;
			color: #fff;
		}

		/* //手机端产品分类 */
		.has-child {
			height: 250px !important;
		}

		.el-dropdown-link,
		.el-dropdown-link-item {
			font-size: 14px !important;
			text-align: left !important;
			padding: 0 20px;
		}
	}

	/* end */
</style>